module.exports = __webpack_public_path__ + "img/mortgage_protection.302922c.svg";